import { FETCH_PLACEMENT_INFO } from "../../actions/sql/constants";
import { SUCCESS, FAILURE, PENDING } from "../../actions/constants";
import { normalizeDataByField } from "../utils/normalize";

const initialState = { isLoading: false, byId: {}, allIds: [] };

export const placementInfo = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PLACEMENT_INFO:
      switch (action.status) {
        case SUCCESS:
          const { byId, allIds } = normalizeDataByField(
            action.placementInfo,
            "Placement_Id"
          );
          return { isLoading: false, byId: { ...byId }, allIds: [...allIds] };
        case FAILURE:
          return {
            isLoading: false,
            byId: { ...state.byId },
            allIds: [...state.allIds]
          };
        case PENDING:
          return {
            isLoading: true,
            byId: { ...state.byId },
            allIds: [...state.allIds]
          };
        default:
          return state;
      }
    default:
      return state;
  }
};
